import api from './api';
export default {
  // Note: only an application's own applicant may raise a dispute (see DisputePolicy@create) — this
  // is here for completeness, but the real applicant-facing flow lives in ApplicantApplicationPage.
  createDispute: async (appId, data) => (await api.post(`/applications/${appId}/dispute`, data)).data,
  getDisputes: async (appId) => (await api.get(`/applications/${appId}/disputes`)).data,
  getDispute: async (id) => (await api.get(`/disputes/${id}`)).data,
  acknowledgeDispute: async (id) => (await api.post(`/disputes/${id}/acknowledge`)).data,
  investigateDispute: async (id, data) => (await api.post(`/disputes/${id}/investigate`, data)).data,
  resolveDispute: async (id, data) => (await api.post(`/disputes/${id}/resolve`, data)).data,
};
